// extracted by mini-css-extract-plugin
export var checkbox = "_91-0";
export var circle = "_91-3";
export var horizontalContainer = "_91-7";
export var sm = "_91-5";
export var switch0 = "_91-2";
export var switchDisabled = "_91-8";
export var switchEnabled = "_91-1";
export var textSwitchContainer = "_91-9";
export var textSwitchOption = "_91-a";
export var textSwitchOptionSelected = "_91-b";
export var verticalContainer = "_91-6";
export var xs = "_91-4";